import React, { useState, useEffect } from 'react';
import { Modal } from 'reactstrap';

// Historial de cambios (auditoría) de un registro eliminado, en modal rk-.
// Reusa el endpoint existente GET /formatos/get_survey_audits/:survey_id —
// incluye la fila "Registro: Activo → Eliminado" con quién lo borró.
const HistoryModal = ({ survey, onClose }) => {
    const [audits, setAudits] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch(`/formatos/get_survey_audits/${survey.id}`, {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin',
        })
            .then(r => r.json())
            .then(data => setAudits(data.audits || []))
            .catch(() => setAudits([]))
            .finally(() => setLoading(false));
    }, [survey.id]);

    return (
        <Modal isOpen toggle={onClose} className="modal-dialog-centered rk-modal modal-lg">
            <div className="rk-modal__header">
                <span className="rk-modal__header-icon"><i className="fas fa-history"></i></span>
                <h5>Historial — {survey.code}</h5>
                <button type="button" className="rk-modal__close" onClick={onClose}><i className="fas fa-times"></i></button>
            </div>
            <div className="rk-modal__body" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                {loading ? (
                    <div className="text-muted">Cargando historial…</div>
                ) : !audits.length ? (
                    <div className="rk-empty">
                        <i className="fas fa-history"></i>
                        <p>Sin modificaciones registradas</p>
                    </div>
                ) : (
                    audits.map(a => (
                        <div key={a.id} style={{ borderBottom: '1px solid #eef1f5', padding: '10px 0' }}>
                            <div style={{ marginBottom: 4 }}>
                                <b>{a.user}</b> <span className="rk-cell-muted">· {a.created_at}</span>
                            </div>
                            <ul style={{ margin: 0, paddingLeft: 18 }}>
                                {a.changes.map((c, i) => (
                                    <li key={i}>
                                        <span className="rk-cell-primary">{c.question}:</span>{' '}
                                        <span className="rk-cell-muted">{c.before || '(vacío)'}</span>
                                        {' → '}
                                        <span>{c.after || '(vacío)'}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))
                )}
            </div>
            <div className="rk-modal__footer">
                <button className="rk-btn rk-btn--ghost" onClick={onClose}>Cerrar</button>
            </div>
        </Modal>
    );
};

export default HistoryModal;
